export default __webpack_public_path__ + "static/media/text-align-justify.09f828de.svg";